import { Button } from '../../components/Button'
import { Text } from '../../components/Text'
import { useAuth } from '../../auth/authContext'
import { useI18n } from '../../i18n'

/**
 * Profile tab: the signed-in Keycloak identity (display-only claims) plus a
 * sign-out action. Rendered inside AppShell, so the header + tab bar already
 * wrap it — this is just the tab content.
 */
export function ProfileScreen() {
  const { t } = useI18n()
  const { claims, logout } = useAuth()

  const name = claims?.name?.trim()
  const email = claims?.email

  return (
    <section className="space-y-8 px-6 py-6">
      <Text as="h1" variant="h1" weight="bold">
        {t('nav.profile')}
      </Text>

      <div className="space-y-1 rounded-lg border border-gray-500 bg-white p-4">
        {name && (
          <Text variant="lg" weight="semibold">
            {name}
          </Text>
        )}
        <Text variant="base" className="text-gray-700">
          {email ?? '—'}
        </Text>
      </div>

      <Button intent="outline" fullWidth onClick={logout}>
        {t('profile.logout')}
      </Button>
    </section>
  )
}
